import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { useHistory } from 'react-router-dom';

type props = {
  clientName: string;
  headback?: string;
};

const HeadBack: React.FunctionComponent<props> = ({ clientName, headback }) => {
  const history = useHistory();
  return (
    <div className="flex w-full">
      <div
        className="mr-4 flex justify-end rounded-full bg-white"
        role="button"
        onClick={() => {
          history.push(headback ? headback : '/groups');
        }}
      >
        <img className="h-8 w-8" src={RightArrow} alt="left Arrow"></img>
      </div>
      <p>{clientName}</p>
    </div>
  );
};

export default HeadBack;
